export enum PortfolioCompositionViewMode {
  Included = "included",
  Excluded = "excluded",
}
